<script lang="ts">
  import type { SelectionParams } from './datatable.types';

  export let itemsSelection: boolean;
  export let selectionParams: SelectionParams | undefined;
  export let showSelectionCount: boolean;
</script>

<div class="mc-datatable__topbar-selection">
  {#if itemsSelection && showSelectionCount && selectionParams != null}
    <div class="center-selection-label">
      {#if selectionParams?.allSelected}
        {#if selectionParams?.excludedIdsFromSelection.length > 0}
          <span
            ><b
              >{selectionParams?.totalItems -
                selectionParams?.excludedIdsFromSelection.length}
              {selectionParams?.selectedLabel || 'selected'}</b
            >
          </span>
        {:else}
          <span><b>{selectionParams?.totalItems + ' selected'}</b> </span>
        {/if}
      {:else}
        <span
          ><b
            >{selectionParams?.idsSelected.length}
            {selectionParams?.selectedLabel || 'selected'}</b
          >
        </span>
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  .mc-datatable__topbar-selection {
    margin-left: 1rem;
  }

  .center-selection-label {
    text-align: center;
  }

  .center-selection-label span {
    line-height: 2;
    display: inline-block;
    vertical-align: middle;
  }
</style>
